import { Box, Grid, Typography } from "@mui/material"
import { ActivityDetailListProps } from "./types"
import { CaptionKeyVertical } from "../../../../../../../components/detailKeyValue/keyCaption.index"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { icons } from "../../../../../../../utils/icons"
import { EvidencesMap } from "../evidencesMap"


export const ActivityDetailList = ({ isForcedClosure, existEvidences, closeMotive, startExecution, endExecution, type, storeAndId, initDate, endDate, unityLocation, initLocation, finishLocation, evidences }: ActivityDetailListProps) => {

    const { t } = useTranslation()
    const styles = useStyles()

    const handleClick = (location: string) => {
        const [latStr, lngStr] = location.split(',');

        const lat = parseFloat(latStr);
        const lng = parseFloat(lngStr);
        const url = `https://www.google.com/maps?q=${lat},${lng}`;
        window.open(url, '_blank');
    };
    const allEvidences = evidences ?
        Object.entries(evidences).flatMap(([key, items]) =>
            items.map(item => ({
                ...item,
            }))
        )
        : []

    return (
        <Box sx={styles.flex}>
            <Box sx={styles.flex}>
                {type && <CaptionKeyVertical captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }} caption={`${t('loogbook.typeOfActivity')}: `} value={type || 'N/A'} />}
                {initDate && <CaptionKeyVertical captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }} caption={`${t('loogbook.titles.startDate')}: `} value={initDate || 'N/A'} />}
                {endDate && <CaptionKeyVertical captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }} caption={`${t('loogbook.titles.endDate')}: `} value={endDate || 'N/A'} />}
                {storeAndId ?
                    <CaptionKeyVertical
                        captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }}
                        caption={t('loogbook.storeId')}
                        value={
                            <Box sx={styles.destionation}>
                                <Typography sx={{ marginRight: 1 }} variant="text_grey" fontWeight='500'>{storeAndId}</Typography>
                                <Typography sx={styles.mapLink} onClick={() => { handleClick(unityLocation) }} variant="text_grey" fontWeight='500' >{icons('open-in-new-tab')}{t('loogbook.viewOnTheMap')}</Typography>
                            </Box>
                        }
                    /> :
                    <CaptionKeyVertical
                        caption={t('loogbook.storeId')}
                        captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }}
                        value={'N/A'} />
                }
            </Box>

            <Box sx={styles.flex}>
                <Typography sx={styles.titles} variant="text_grey" fontWeight='bold' fontSize={16}>{t('loogbook.titles.execution')}</Typography>
                <CaptionKeyVertical captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }} caption={`${t('loogbook.titles.closeType')}: `} value={isForcedClosure ? <Typography sx={styles.error} variant="text_grey" fontWeight='500'>{icons('info')}{t('loogbook.titles.forced')}</Typography> : <Typography variant="text_grey" fontWeight='500'>{t('loogbook.titles.normal')}</Typography>} />
                {initLocation ?
                    <CaptionKeyVertical
                        caption={t('loogbook.initLocation')}
                        captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }}
                        value={
                            <Typography sx={styles.mapLink} onClick={() => { handleClick(initLocation) }} variant="text_grey" fontWeight='500' >{icons('open-in-new-tab')}{t('loogbook.viewOnTheMap')}</Typography>} /> :
                    <CaptionKeyVertical
                        caption={t('loogbook.initLocation')}
                        captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }}
                        value={'N/A'} />
                }
                {finishLocation ?
                    <CaptionKeyVertical
                        caption={t('loogbook.finishLocation')}
                        captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }}
                        value={
                            <Typography sx={styles.mapLink} onClick={() => { handleClick(finishLocation) }} variant="text_grey" fontWeight='500' >{icons('open-in-new-tab')}{t('loogbook.viewOnTheMap')}</Typography>} /> :
                    <CaptionKeyVertical
                        caption={t('loogbook.finishLocation')}
                        captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }}
                        value={'N/A'} />
                }
                {startExecution && <CaptionKeyVertical captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }} caption={`${t('loogbook.titles.startDate')}: `} value={startExecution || 'N/A'} />}
                {endExecution && <CaptionKeyVertical captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }} caption={`${t('loogbook.titles.endDate')}: `} value={endExecution || 'N/A'} />}
            </Box>

            {isForcedClosure &&
                <Box sx={styles.flex}>
                    <Typography sx={styles.titles} variant="text_grey" fontWeight='bold' fontSize={16}>{t('loogbook.titles.forcedComment')}</Typography>
                    <Typography variant="text_grey" fontWeight='500'>{closeMotive}</Typography>
                </Box>
            }

            {existEvidences &&
                <Box sx={styles.flex}>
                    <Typography sx={styles.titles} variant="text_grey" fontWeight='bold' fontSize={16}>{t('loogbook.titles.evidences')}</Typography>

                    <Grid container spacing={2}>
                        {
                            allEvidences && allEvidences.map((item) => (

                                <Grid item xl={4} lg={6} md={6} sm={12} xs={12}>
                                    <EvidencesMap
                                    evidences={item}
                                    type={item.type}
                                />
                                </Grid>
                            ))
                        }
                        </Grid>
                    </Box>
            }
        </Box>
    )
}